import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import SergaOS from "./components/SergaOS";
import { AuthProvider } from "./contexts/AuthContext";
import "./amplify-config";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <Router>
          <Routes>
            {/* SERGA OS — full-screen 3D experience with an in-scene auth gate.
                Login lives inside the world (see SergaOS.tsx), so there is no
                separate /login route anymore. */}
            <Route path="/" element={<SergaOS />} />
            {/* legacy paths (e.g. /login) fall back to the OS + its auth gate */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </AuthProvider>
  );
};

export default App;
